// Constraint — the neutral atom of the quality model.
//
// Per `docs/model/constraints.md` (The collapse): everything we used to
// call a Rule, a Check, a quality signal, a policy requirement is at
// bottom ONE thing — a checkable predicate about a material. A
// Constraint carries **no force and no owner**. It knows how its verdict
// is PRODUCED and how it READS to a person. That is all. Force is
// assigned by a Policy membership (`./policy.ts`), never stamped here.
//
// Two parts only:
//   - `production` — how the verdict is produced (`computed | judged`).
//     The load-bearing axis: it IS the pure-core / impure-shell line.
//   - `description` (optional) — author-facing free text. Payload, not
//     behaviour: it changes how the constraint reads, never how it acts.
//
// Pure module. No I/O, no clocks, no casts (except the sanctioned brand
// site in `mk`).
export { from, mk, mkConstraint, to };
import { mkParser } from "../_ids/parse.js";
const mk = (s) => s;
const to = mkParser("ConstraintId", mk);
const from = (id) => id;
const mkConstraint = (id, production, description) => description === undefined
    ? { id, production }
    : { id, production, description };
//# sourceMappingURL=constraint.js.map